import "core-js/modules/es6.array.find.js";
import { useQuery } from '@nerdwallet/apollo';
import { ABQuery } from './queries';

/**
 * React hook that returns AB test info.
 * Abstraction around useQuery for fetching AB test data
 */
var useABQuery = function useABQuery(_ref) {
  var _data$abExperiments, _experiment$variants;

  var testName = _ref.testName;

  var _useQuery = useQuery(ABQuery, {
    variables: {
      testName: testName
    },
    errorPolicy: 'all'
  }),
      loading = _useQuery.loading,
      data = _useQuery.data,
      error = _useQuery.error;

  if (loading) return {
    loading: loading
  };
  if (error) return {
    loading: loading,
    error: error
  };
  var experiment = data === null || data === void 0 ? void 0 : (_data$abExperiments = data.abExperiments) === null || _data$abExperiments === void 0 ? void 0 : _data$abExperiments[0];
  var variant = ((_experiment$variants = experiment === null || experiment === void 0 ? void 0 : experiment.variants) !== null && _experiment$variants !== void 0 ? _experiment$variants : []).find(function (v) {
    return v.variantId === (experiment === null || experiment === void 0 ? void 0 : experiment.assignedVariant);
  });
  var isForcedVariant = experiment === null || experiment === void 0 ? void 0 : experiment.isForcedVariant;
  return {
    loading: loading,
    variant: variant,
    isForcedVariant: isForcedVariant,
    experiment: experiment,
    error: error
  };
};

export default useABQuery;